import { Controller } from '@hotwired/stimulus';
import { MDCRadio } from '@material/radio';

export default class extends Controller {
  static targets = [
    'notProspectiveFields',
    'stoppageReason',
    'prospectiveRadio',
    'notProspectiveRadio'
  ];

  connect() {
    this.initRadios();
    this.sync();
  }

  // Initialize Material Design radios
  initRadios() {
    this.prospective?.destroy?.();
    this.notProspective?.destroy?.();
    this.prospective = new MDCRadio(this.prospectiveRadioTarget);
    this.notProspective = new MDCRadio(this.notProspectiveRadioTarget);
  }

  // Keep radio + hidden fields synced
  sync() {
    const selected = this.element.querySelector(
      'input[name*="[was_prospective]"]:checked'
    );
    const val = (selected?.value ?? '').toLowerCase();
    const isNo = val === '0' || val === 'false';

    if (isNo) {
      this.notProspectiveStoppage();
    } else {
      this.prospectiveStoppage();
    }
  }

  // Radio actions from the template
  prospectiveStoppage() {
    this.notProspectiveFieldsTarget.classList.add('hide');
    this.stoppageReasonTarget.required = false;
  }

  notProspectiveStoppage() {
    this.notProspectiveFieldsTarget.classList.remove('hide');
    this.stoppageReasonTarget.required = true;
  }
}
